import { Config } from "../../../shared/core/config/config";

const toStaticImageUri = (filename: string) => `/static/${filename}`;
const toStaticImagesUri = (filenames: string[]) => filenames.map(toStaticImageUri);

export const StaticAssets = {
  carouselImages: toStaticImagesUri(Config.APP_CAROUSEL_IMAGES),
  registerImage: toStaticImageUri(Config.APP_REGISTER_IMAGE),
  logo: toStaticImageUri(Config.APP_LOGO_IMAGE),

  // Assets bundled with the app rather than provided per tenant. They are served from /static
  // because importing an image from JS does not resolve to its URL in this project.
  brandLogo: toStaticImageUri("logo.svg"),
  fluxIncome: toStaticImageUri("flux-income.svg"),
  fluxExpense: toStaticImageUri("flux-expense.svg"),
  menuHouse: toStaticImageUri("menu_house.svg"),
  menuCard: toStaticImageUri("menu_card.svg"),
  menuProfile: toStaticImageUri("menu_profil.svg"),
  countdown: toStaticImageUri("countdown.svg"),
  warningCircle: toStaticImageUri("warning_circle.svg"),
  confirmation: toStaticImageUri("confirmation.svg"),
  copy: toStaticImageUri("copy.svg"),
  download: toStaticImageUri("download.svg"),
  share: toStaticImageUri("share.svg"),
  cardNew: toStaticImageUri("card_new.svg"),
  cardPincode: toStaticImageUri("card_pincode.svg"),
  cardOpposition: toStaticImageUri("card_opposition.svg"),
  cardLimits: toStaticImageUri("card_limits.svg"),
  cardDetails: toStaticImageUri("card_details.svg"),
  cardActivate: toStaticImageUri("card_activate.svg"),
  justifyTransaction: toStaticImageUri("justify_transaction.svg"),
  qualifyTransaction: toStaticImageUri("qualify_transaction.svg"),
  justified: toStaticImageUri("justified.svg"),
  eye: toStaticImageUri("eye.svg"),
  trash: toStaticImageUri("trash.svg"),
  close: toStaticImageUri("close.svg"),
  profileProfile: toStaticImageUri("profile_profile.svg"),
  profileSettings: toStaticImageUri("profile_settings.svg"),
  settingsTalk: toStaticImageUri("settings_talk.svg"),
  settingsPincode: toStaticImageUri("settings_pincode.svg"),
};
